import { create } from 'zustand'
import { platSdkGatewayApi } from '@root/api/api'
import { IBindingsStore } from '@store/types'
import { reqHeaders } from '@root/components/Cyber/constansts'

const useBindingsStore = create<IBindingsStore>((set, get) => ({
  bindings: [],
  error: null,
  isLoading: false,
  isNeedUpdateBindings: true,
  setUpdateBindings: (isNeedUpdateBindings: boolean) => set(() => ({ isNeedUpdateBindings })),
  fetchBindings: () => {
    if (!get().isNeedUpdateBindings || get().isLoading) {
      return
    }

    set({ isLoading: true, error: null })
    // TODO: вынести значение retryCount в консул
    let retryCount = 0

    const fetcher = async () => {
      try {
        const res = await platSdkGatewayApi.getBindingsSdk({
          headers: {
            ...reqHeaders,
          },
        })

        if (res?.data) {
          // TODO Удалить фильтрацию по продуктам когда понадобятся продукты банка
          set({
            bindings: res?.data?.bindings,
            isLoading: false,
            isNeedUpdateBindings: false,
          })
        }
      } catch (error) {
        if (retryCount < 2) {
          set({ error })
          retryCount++
          setTimeout(() => {
            fetcher()
          }, 1000)
        } else {
          set({ error, isLoading: false, isNeedUpdateBindings: false })
        }
      }
    }

    fetcher()
  },
}))

export default useBindingsStore
